__turbopack_context__.v({
  "image": "ScrollToTop-module-scss-module__g53VnW__image",
  "scrollTopButton": "ScrollToTop-module-scss-module__g53VnW__scrollTopButton",
  "wrapper": "ScrollToTop-module-scss-module__g53VnW__wrapper",
});
